export const FETCH_ALLATTENDENCE_REQUEST = 'FETCH_ALLATTENDENCE_REQUEST'
export const FETCH_ALLATTENDENCE_SUCCESS = 'FETCH_ALLATTENDENCE_SUCCESS'
export const FETCH_ALLATTENDENCE_FALIURE = 'FETCH_ALLATTENDENCE_FALIURE'
